import { Component } from "@builder.io/sdk";

export const featuresCiVrConfig: Component = {
  name: "Features CI-VR",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "features",
      friendlyName: "Section ID",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "title",
      type: "string",
      defaultValue: "Features",
      friendlyName: "Section Title",
      helperText:
        "The main heading that appears at the top of the features section",
      required: true,
    },
    {
      name: "features",
      type: "list",
      friendlyName: "VR Features List",
      defaultValue: [
        {
          title: "360° Immersive Environment",
          ariaLabel: "Feature: 360° Immersive Environment",
          iconName: "immersive-experience-360",
        },
        {
          title: "4K True RGB Display",
          ariaLabel: "Feature: 4K True RGB Display",
          iconName: "resolution",
        },
        {
          title: "Professionally Designed Scenarios",
          ariaLabel: "Feature: Professionally Designed Scenarios",
          iconName: "professionally-designed-scenarios",
        },
        {
          title: "Engaging Learning Design",
          ariaLabel: "Feature: Engaging Learning Design",
          iconName: "engaging-learning-design",
        },
        {
          title: "Wireless PC VR streaming",
          ariaLabel: "Feature: Wireless PC VR streaming",
          iconName: "wireless-pc-vr-training",
        },
        {
          title: "Extremely Comfortable Headset",
          ariaLabel: "Feature: Extremely Comfortable Headset",
          iconName: "comfortable-headset",
        },
      ],
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Feature Title",
          helperText:
            "Short, descriptive title for this VR hardware/software feature",
          required: true,
        },
        {
          name: "ariaLabel",
          type: "string",
          friendlyName: "Accessibility Label",
          helperText:
            "Descriptive label for screen readers (should include 'Feature:' prefix)",
          required: true,
        },
        {
          name: "iconName",
          type: "string",
          friendlyName: "Icon Selection",
          helperText:
            "Choose the visual icon: immersive-experience-360 (360°), resolution (4K display), professionally-designed-scenarios (scenarios), engaging-learning-design (learning), wireless-pc-vr-training (wireless), comfortable-headset (comfort)",
          enum: [
            "immersive-experience-360",
            "resolution",
            "professionally-designed-scenarios",
            "engaging-learning-design",
            "wireless-pc-vr-training",
            "comfortable-headset",
          ],
          required: true,
        },
      ],
      helperText:
        "Add or remove VR technology features to highlight the technical capabilities and benefits of the VR system. Each feature includes a title, accessibility label, and icon.",
      min: 1,
      max: 8,
    },
    {
      name: "layout",
      type: "string",
      friendlyName: "Layout Style",
      defaultValue: "grid",
      enum: ["grid", "list"],
      helperText:
        "Choose layout: grid (3-column responsive layout) or list (vertical stacked)",
      advanced: true,
    },
    {
      name: "backgroundColor",
      type: "string",
      friendlyName: "Background Color",
      defaultValue: "primary-100",
      enum: ["white", "primary-100", "secondary-100"],
      helperText:
        "Background color for the section: white, primary-100 (Light Primary), or secondary-100 (Light Secondary)",
      advanced: true,
    },
    {
      name: "textColor",
      type: "string",
      friendlyName: "Title Text Color",
      defaultValue: "primary-600",
      enum: ["primary-600", "neutral-600", "secondary-600"],
      helperText:
        "Color scheme for the main title: primary-600 (Teal), neutral-600 (Dark Gray), or secondary-600 (Orange)",
      advanced: true,
    },
    {
      name: "gridColumns",
      type: "string",
      friendlyName: "Grid Columns",
      defaultValue: "responsive",
      enum: ["responsive", "2-columns", "3-columns", "4-columns"],
      helperText:
        "Number of columns for grid layout: responsive (2 on mobile, 3 on desktop), or fixed column count",
      advanced: true,
      showIf: "options.get('layout') === 'grid'",
    },
  ],
};
